<template>
  <div class="message-banner" :class="style">
    <div class="d-flex align-items-center" v-if="type === 'error'">
      <img
        src="@/assets/images/icons/error-message-icon.svg"
        alt="Message icon"
        class="me-2"
      />
      <p class="mb-0" v-html="message"></p>
    </div>

    <div class="d-flex align-items-center" v-if="type === 'success'">
      <img
        src="@/assets/images/icons/success-message-icon.svg"
        alt="Message icon"
        class="me-2"
      />
      <p class="mb-0" v-html="message"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type", "message", "classes"],
  data() {
    return {
      style: [],
    };
  },
  methods: {
    parseClasses() {
      if (this.type) {
        this.style.push(this.type);
      }

      if (this.classes) {
        this.style.push(...this.classes);
      }

      this.style = this.style.join(" ");
    },
  },
  mounted() {
    this.parseClasses();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";

.error {
  background: #ff5f00;
  border-radius: 9px;
  padding: 18px 25px;
  font-family: $worksans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}

.success {
  background: #06e775;
  border-radius: 9px;
  padding: 18px 25px;
  font-family: $worksans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
}

.position-bottom-center {
  width: fit-content;
  position: fixed;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/utils/MessageBanner.vue